/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";
import { CleaningAgent } from "../mediaCleaning.types";

interface Props {
	setCleaningMethod: (method: string) => void;
	setSopReference: (reference: string) => void;
	setSelectedCleaningAgent: (cleaningAgent: CleaningAgent) => void;
	cleaningMethod: string;
	cleaningAgents: CleaningAgent[];
	selectedCleaningAgent?: CleaningAgent ;
	sopReference: string;
	errors: any;
	setErrors: React.Dispatch<React.SetStateAction<any>>;
}

const PAExecutionDetails: React.FC<Props> = ({
	setSelectedCleaningAgent,
	setCleaningMethod,
	cleaningAgents,
	setSopReference,
	cleaningMethod,
	selectedCleaningAgent,
	sopReference,
	errors,
	setErrors,
}) => {
	const { t } = useTranslation();

	const hasError = !!errors.cleaningAgent;

	return (
		<div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
			<div className="px-8 py-2 border-b border-slate-100 bg-slate-50/50 flex items-center gap-3">
				<span className="material-symbols-outlined text-[#FF7043] text-xl mb-2">
					settings_suggest
				</span>
				<h3 className="text-xs font-black text-[#1E293B] uppercase tracking-[0.15em]">
					{t("postAutoclaveProcess.mediaCleaning.executionDetails")}
				</h3>
			</div>
			<div className="px-8 py-2 grid grid-cols-3 gap-10">
				{/* Cleaning Method */}
				<div className="space-y-2">
					<label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
						{t("postAutoclaveProcess.mediaCleaning.cleaningMethod")}
					</label>
					<div className="flex bg-slate-100/80 p-1 rounded-xl border border-slate-200/50">
						<button
							onClick={() => setCleaningMethod("Manual")}
							className={`flex-1 py-2 text-[11px] font-black uppercase tracking-wider rounded-xl transition-all duration-300 border-none ${
								cleaningMethod === "Manual"
									? "bg-white text-[#1E293B] shadow-md"
									: "hover:text-slate-600"
							}`}
						>
							{t("postAutoclaveProcess.mediaCleaning.manual")}
						</button>
						<button
							onClick={() => setCleaningMethod("Washer")}
							className={`flex-1 py-2 text-[11px] font-black uppercase tracking-wider rounded-xl transition-all duration-300 border-none ${
								cleaningMethod === "Washer"
									? "bg-white text-[#1E293B] shadow-md"
									: "hover:text-slate-600"
							}`}
						>
							{t("postAutoclaveProcess.mediaCleaning.washer")}
						</button>
					</div>
				</div>

				{/* Cleaning Agent */}
				<div className="space-y-2">
					<label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
						{t("postAutoclaveProcess.mediaCleaning.cleaningAgent")}  <span className="text-red-500">*</span>
					</label>
					<div className="relative group">
						<select
							value={selectedCleaningAgent?.id || ""}
							onChange={(e) => {
								const selectedId = e.target.value;
								const fullAgentObject = cleaningAgents.find(
									(agent) => agent.id === selectedId,
								);
								if (fullAgentObject) {
									setSelectedCleaningAgent(fullAgentObject);
								}
								setErrors((prev: any) => ({
									...prev,
									cleaningAgent: "",
								}));
							}}
							className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-[12px] text-slate-700 outline-none focus:border-[#FF7043] transition-all"
						>
							<option value="" disabled>
								{t("postAutoclaveProcess.mediaCleaning.selectACleaningAgent")}
							</option>
							{cleaningAgents.map((agent: CleaningAgent) => (
								<option key={agent.id} value={agent.id}>
									{agent.name}
								</option>
							))}
						</select>
					</div>
					{hasError && (
						<p className="text-[11px] text-red-500 mt-2">
							{t("postAutoclaveProcess.mediaCleaning.cleaningAgentRequired")}
						</p>
					)}
				</div>

				{/* SOP Reference */}
				{/* <div className="space-y-2">
					<label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
						{t("postAutoclaveProcess.mediaCleaning.sopReference")}
					</label>
					<div className="relative">
						<input
							type="text"
							value={sopReference}
							onChange={(e) => setSopReference(e.target.value)}
							className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-[12px] text-slate-700 outline-none focus:ring-2 focus:ring-orange-100 focus:border-[#FF7043] transition-all"
						/>
						<span className="material-symbols-outlined absolute right-4 top-1/2 -translate-y-1/2 text-slate-300">
							menu_book
						</span>
					</div>
				</div> */}
				
			</div>
		</div>
	);
};

export default PAExecutionDetails;
